module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2h2",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_9781614230076_Foreword"
    }
  }, [_vm._v("Foreword, by Martin Perschler")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/07_9781614230076_Preface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08_9781614230076_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_9781614230076_Prologue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue. April 19, 1861, Baltimore, Maryland")])]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_9781614230076_CH01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Baltimore on the Eve of the Pratt Street Riot: April 1, 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_9781614230076_CH02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. A Prelude to Baltimore’s Bloody Riot: April 12, 1861, Fort Sumter, Charleston, South Carolina")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_9781614230076_CH03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Trying to Prevent a Riot: April 15 to April 18, 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_9781614230076_CH04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. A Plan to Assassinate Lincoln")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781614230076_CH05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. The Civil War’s First Blood: Pratt Street, Baltimore, April 19, 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781614230076_CH06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. More Violence: Baltimore Is Cut Off from the North, April 19–27, 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_9781614230076_CH07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. Lincoln Declares Martial Law: April 27 to May 13, 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_9781614230076_CH08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. Some Questionable Arrests")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_9781614230076_CH09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. The Story of Habeas Corpus")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_9781614230076_CH10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. Baltimore: A Prisoner of Its Geography")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_9781614230076_CH11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. Lincoln’s Last Ride: The Aftermath of the Pratt Street Riot, April 21, 1865, to Present")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_9781614230076_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I. The Lives of Some of the Participants After the Pratt Street Riot and the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/22_9781614230076_Appendix1"
    }
  }, [_vm._v("Appendix II. Pratt Street Riot Markers")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_9781614230076_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources and Materials Used in Research")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_9781614230076_AuthorNote",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90a0fbfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_9781614230076_Contents.vue
// module id = 69
// module chunks = 0